import {
  Box,
  CssBaseline,
  ThemeProvider,
  createTheme
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { SnackbarProvider } from "notistack";
import { useDispatch } from "react-redux";
import { ConversationsProvider } from "./ConversationsContext";
import ScrollToTop from "./ScrollToTop";
import Camera from "./components/Camera";
import Header from "./components/Header";
import History from "./components/History";
import MoreInfo from "./components/MoreInfo";
import NotFound from "./components/NotFound";
import WebcamCapture from "./components/camera/WebcamCapture";
import { BarcodeProvider } from "./components/contexts/Barcodecontext";
import { LikedProductsProvider } from "./components/contexts/LikedProductsContext";
import { ProductsProvider } from "./components/contexts/ProductsContext";
import { RecentSearchesProvider } from "./components/contexts/RecentSearchesContext";
import { UPCprovider } from "./components/contexts/UPCcontext";
import { UserProvider } from "./components/contexts/UserContext";
import Products from "./components/products/Products";
import Chat from "./components/products/Products.chat";
import Details from "./components/products/Products.details";
import Home from "./components/products/Products.home";
import Likes from "./components/products/Products.likes";
import Reviews from "./components/products/Products.reviews";
import Search from "./components/products/Products.search";
import BarcodeScanner from "./components/scanner/Scandit";
import ScannerComponent from "./components/scanner/ScannerComponent.jsx";
import LogIn from "./components/user/LogIn";
import SignUp from "./components/user/SignUp";
import { fetchLikedProducts } from "./store/reducers/userReducer.js";
// import Scanner from "./components/scanner/ScannerV2";

function App() {
  const [mode, setMode] = useState(false);
  const [productInfo, setProductInfo] = useState(null);
  const [camera, setCamera] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchLikedProducts());
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const theme = useMemo(
    () =>
      createTheme({
        typography: {
          fontFamily: "Poppins, sans-serif",
        },
        palette: {
          mode: mode ? "dark" : "light",
          background: {
            default: mode ? "#303030" : "#e0e0e0",
            paper: mode ? "#28242C" : "#ffffff",
            component: mode ? "#18141C" : "#F5F5F5",
            background: mode ? "#ffffff" : "#ffffff",
            text: mode ? "#ffffff" : "#000000",
          },
          primary: {
            main: "#DF552E",
          },
          secondary: {
            main: "#DF552E",
          },
        },
        components: {
          MuiOutlinedInput: {
            styleOverrides: {
              root: {
                "& fieldset": {
                  borderColor: "transparent",
                },
                borderRadius: "14px",
                backgroundColor: mode ? "#18141C" : "#F5F5F5",
              },
            },
          },
          MuiButton: {
            defaultProps: {
              disableElevation: true,
            },
            styleOverrides: {
              root: {
                "&:hover": {
                  backgroundColor: mode ? "#18141C" : "#F5F5F5",
                },
                borderRadius: "14px",
              },
            },
          },
        },
      }),
    [mode]
  );

  return (
    <Router>
      <ScrollToTop />
      <SnackbarProvider>
      <UserProvider>
        <RecentSearchesProvider>
          <LikedProductsProvider>
            <ProductsProvider>
              <BarcodeProvider>
                <UPCprovider>
                  <ConversationsProvider>
                    <ThemeProvider theme={theme}>
                      <CssBaseline />
                      <Header />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-evenly",
                          height: "100vh",
                          overflow: "auto",
                          backgroundColor: "background.background",
                          paddingTop: "60px",
                          margin: "0",
                          width: "100vw",
                        }}
                      >
                        <Routes>
                          {/* <Route path="/" element={<ProtectedRoute />}> */}
                          {/* <Route
                            index
                            element={
                              <Grid
                                container
                                spacing={1}
                                alignItems="center"
                                justifyContent="center"
                              >
                                <Grid
                                  item
                                  xs={4}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Box sx={{ width: "50vh" }}>
                                    <ProductInfo />
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={8}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Box sx={{ width: "80%" }}>
                                    <Chatbot />
                                  </Box>
                                </Grid>
                              </Grid>
                            }
                          /> */}
                          <Route
                            index
                            // element={
                            //   windowWidth <= 768 ? <Home /> : <HomeLarge />
                            // }
                            element={
                              <Products />
                            }
                          />
                          {/* </Route> */}
                          {/* <Route path="/" element={<ProtectedRoute />}> */}
                          <Route path="/history" element={<History />} />
                          <Route path="/product-info" element={<MoreInfo />} />
                          <Route
                            path="/scanner"
                            element={
                              <Camera
                                productInfo={productInfo}
                                setProductInfo={setProductInfo}
                                camera={camera}
                                setCamera={setCamera}
                              />
                            }
                            // element={<Scanner />}
                          />
                          {/* </Route> */}
                          <Route path="/home" element={<Home />} />
                          <Route path="/login" element={<LogIn />} />
                          <Route path="/signup" element={<SignUp />} />
                          <Route path="/camera" element={<WebcamCapture />} />
                          <Route path="/scandit" element={<BarcodeScanner />} />
                          <Route path="*" element={<NotFound />} />
                          <Route path="/products" element={<Products />} />
                          <Route path="/scannerTest" element={<ScannerComponent />} />
                          <Route
                            path="/products/details/:id"
                            element={<Details />}
                          />
                          <Route
                            path="/products/details-d/:id"
                            element={<Details />}
                          />
                          {/* <Route
                            path="/products/details-d/"
                            element={<DetailsLarge />}
                          /> */}
                          <Route path="/products/chat" element={<Chat />} />
                          <Route path="/products/chat/:id" element={<Chat />} />
                          <Route
                            path="/products/reviews/:id"
                            element={<Reviews />}
                          />
                          <Route path="/products/search" element={<Search />} />
                          <Route path="/products/likes" element={<Likes />} />
                        </Routes>
                      </Box>
                    </ThemeProvider>
                  </ConversationsProvider>
                </UPCprovider>
              </BarcodeProvider>
            </ProductsProvider>
          </LikedProductsProvider>
        </RecentSearchesProvider>
      </UserProvider>
      </SnackbarProvider>
    </Router>
  );
}

export default App;
